import { render, staticRenderFns } from "./Incentive.vue?vue&type=template&id=4c4a4c6a&"
import script from "./Incentive.vue?vue&type=script&lang=js&"
export * from "./Incentive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/0/37614586/myshop/myshop/myshop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c4a4c6a')) {
      api.createRecord('4c4a4c6a', component.options)
    } else {
      api.reload('4c4a4c6a', component.options)
    }
    module.hot.accept("./Incentive.vue?vue&type=template&id=4c4a4c6a&", function () {
      api.rerender('4c4a4c6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/WEB-INF/views/fmfmo/common/components/Incentive.vue"
export default component.exports